const IMAGE_BASE = 'https://wvxvb.cn/images/'

export function resolveImageUrl(imageName) {
	if (!imageName) return ''
	const raw = String(imageName).trim()
	if (/^https?:\/\//i.test(raw)) return raw
	const clean = raw.replace(/^\/static\/images\//, '').replace(/^\/+/, '')
	return IMAGE_BASE + clean
}
